export const APP_SETTINGS = {
  adobeAnalyticsEnabled: true,
};
